import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import styled from 'styled-components';
import { Image } from '@/shared/ui/image';
import { useEffect, useState } from 'react';
import { Line, TitleContainer } from '@/shared/ui/footer/styles';

export const ResponsibleGambling = () => {
  const t = useScopedI18n('common.footer');
  const [iconCount, setIconCount] = useState();

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window.innerWidth;
      if (innerWidth < 380) {
        setIconCount(2);
      } else {
        setIconCount(3);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const buttons = [
    { icon: 'gamble-aware', id: 0, link: 'https://www.gambleaware.org/' },
    { icon: '18', id: 1, link: 'https://www.gambleaware.org/' },
    { icon: 'gordon-moody', id: 2, link: '' },
  ];

  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">
          {t('responsible_gambling').toUpperCase()}
        </BodyTextRegularB>
        <Line />
      </TitleContainer>
      <Content>
        {buttons.slice(0, iconCount).map((button) => (
          <PayButton key={button.id} href={button.link} target="_blank">
            <Image
              src={`/images/icons/footer/rg-${button.icon}.svg`}
              alt={button.icon}
              width={80}
              height={55}
            />
          </PayButton>
        ))}
      </Content>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
const Content = styled.div`
  display: flex;
  justify-content: space-between;
`;
const PayButton = styled.a`
  width: 80px;
  height: 55px;
`;
